import { LocationStrategy } from "@angular/common";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { IBaseModel } from "../models/base.model";
import { BaseService } from "./base.service";
import { IAtividadeTipoTrabalhoFaseModel } from "../models/atividade-tipo-trabalho.model";
import { FiltroModel } from "../models/filtro.model";
import { filterBy } from "../core/helpers/filterby";

@Injectable({
    providedIn: 'root',
})
export class AtividadeTipoTrabalhoFaseService extends BaseService {
    constructor(httpClient: HttpClient, locationStrategy: LocationStrategy) {
        super(httpClient, locationStrategy);
    }

    public obterTodos(filtro: FiltroModel): Promise<IBaseModel<IAtividadeTipoTrabalhoFaseModel[]>> {
        return this.httpClient
            .get<IBaseModel<IAtividadeTipoTrabalhoFaseModel[]>>(filterBy(filtro, `${this.apiBaseUrl}/AtividadeTipoTrabalhoFase`))
            .toPromise();
    }

    public obterPorAtividadeTipoTrabalho(AtividadeTipoTrabalhoId: number): Promise<IBaseModel<IAtividadeTipoTrabalhoFaseModel[]>> {
        return this.httpClient
            .get<IBaseModel<IAtividadeTipoTrabalhoFaseModel[]>>(`${this.apiBaseUrl}/AtividadeTipoTrabalhoFase/obter-por-atividade-tipo-trabalho/${AtividadeTipoTrabalhoId}`)
            .toPromise();
    }

    public async obterPorId(id: number): Promise<IBaseModel<IAtividadeTipoTrabalhoFaseModel>> {
        return this.httpClient
            .get<IBaseModel<IAtividadeTipoTrabalhoFaseModel>>(`${this.apiBaseUrl}/AtividadeTipoTrabalhoFase/${id}`)
            .toPromise();
    }

    public async inserir(model: IAtividadeTipoTrabalhoFaseModel): Promise<IBaseModel<IAtividadeTipoTrabalhoFaseModel>> {
        return this.httpClient
            .post<IBaseModel<IAtividadeTipoTrabalhoFaseModel>>(`${this.apiBaseUrl}/AtividadeTipoTrabalhoFase`, model)
            .toPromise();
    }

    public async atualizar(model: IAtividadeTipoTrabalhoFaseModel): Promise<IBaseModel<IAtividadeTipoTrabalhoFaseModel>> {
        return this.httpClient
            .put<IBaseModel<IAtividadeTipoTrabalhoFaseModel>>(`${this.apiBaseUrl}/AtividadeTipoTrabalhoFase/${model.id}`, model)
            .toPromise();
    }

    public async excluir(id: number): Promise<IBaseModel<void>> {
        return this.httpClient
            .delete<IBaseModel<void>>(`${this.apiBaseUrl}/AtividadeTipoTrabalhoFase/excluir/${id}`, {})
            .toPromise();
    }
}